module.exports = __webpack_public_path__ + "img/Trans_V-2.3646be1b.svg";